import { Auth } from 'aws-amplify';

export default defineNuxtPlugin(() => {
  const getAuthInfo = async () => {
    try {
      const user = await Auth.currentAuthenticatedUser();

      const username = user.getUsername();
      const groups = user.signInUserSession.accessToken.payload['cognito:groups'] || [];
      const idToken = user.signInUserSession.idToken.jwtToken;
      const accessToken = user.signInUserSession.accessToken.jwtToken;

      if (process.dev) {
        console.log('[AuthInfo] Authenticated user:', username);
        console.log('[AuthInfo] Groups:', groups);
      }

      return {
        authenticated: true,
        username,
        groups,
        authMode: 'AMAZON_COGNITO_USER_POOLS',
        idToken,
        accessToken,
      };
    } catch (error) {
      if (process.dev) {
        console.warn('[AuthInfo] No authenticated user.', error);
      }

      return {
        authenticated: false,
        username: null,
        groups: [],
        authMode: 'AWS_IAM',
        idToken: null,
        accessToken: null,
      };
    }
  };

  return {
    provide: {
      authInfo: getAuthInfo, // elérhető: useNuxtApp().$authInfo()
    },
  };
});
